import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const HomeIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.163 9.536C19.367 9.7221 19.6833 9.7076 19.8694 9.50361C20.0555 9.29961 20.041 8.98338 19.837 8.79727L10.337 0.130618C10.1461 -0.0435394 9.85392 -0.0435394 9.66301 0.130618L0.163015 8.79727C-0.0409858 8.98338 -0.0554866 9.29961 0.130627 9.50361C0.31674 9.7076 0.63299 9.7221 0.836991 9.536L2.5332 7.98858V19.5C2.5332 19.7762 2.75706 20 3.0332 20H7.4672C7.47264 20 7.47806 19.9999 7.48346 19.9997H12.5169C12.5223 19.9999 12.5278 20 12.5332 20H16.9672C17.2433 20 17.4672 19.7762 17.4672 19.5V7.98894L19.163 9.536ZM12.0332 18.9997V13.3333H7.9672V18.9997H12.0332ZM3.5332 7.09152L3.53298 7.0765L10 1.17677L16.4672 7.07666V19H13.0332V12.8333C13.0332 12.5572 12.8093 12.3333 12.5332 12.3333H7.4672C7.19106 12.3333 6.9672 12.5572 6.9672 12.8333V19H3.5332V7.09152Z'
      />
    </svg>
  );
};
